import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {Select2} from 'shared/components';

const WeekStartDaySelect = observer(({uiState}) => {
  const {policy, errors} = uiState;

  return (
    <Select2
      value={policy.weekStartDay}
      onChange={e => policy.merge({weekStartDay: e.target.value})}
      errorMessage={errors.weekStartDay}
    >
      <option value={0}>{t('time_tracking.manage.policies.edit.days_of_week.Sunday')}</option>
      <option value={1}>{t('time_tracking.manage.policies.edit.days_of_week.Monday')}</option>
      <option value={2}>{t('time_tracking.manage.policies.edit.days_of_week.Tuesday')}</option>
      <option value={3}>{t('time_tracking.manage.policies.edit.days_of_week.Wednesday')}</option>
      <option value={4}>{t('time_tracking.manage.policies.edit.days_of_week.Thursday')}</option>
      <option value={5}>{t('time_tracking.manage.policies.edit.days_of_week.Friday')}</option>
      <option value={6}>{t('time_tracking.manage.policies.edit.days_of_week.Saturday')}</option>
    </Select2>
  );
});

export default WeekStartDaySelect;
